import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const CommonTooltip = ({
  text,
  placement = "top",
  id,
  className = "",
  style = {},
  children,
  ellipsis = false,
}) => {
  const contentStyle = ellipsis
    ? {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        ...style,
      }
    : style;

  const Wrapper = (
    <div className={className} style={contentStyle}>
      {children || text || ""}
    </div>
  );

  if (!text) {
    return Wrapper;
  }

  return (
    <OverlayTrigger
      placement={placement}
      overlay={<Tooltip id={id}>{text}</Tooltip>}
    >
      {Wrapper}
    </OverlayTrigger>
  );
};

export default CommonTooltip;
